import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled, useMediaQuery } from "@mui/material";
import cn from "clsx";
import { Loading } from "./Loading";
import { Text } from "./Text";
var Content = styled('div')(function() {
    return {
        '> *': {
            marginBottom: 0
        },
        alignItems: 'center',
        display: 'flex'
    };
});
export var Header = function(props) {
    var _props_className, _props_className1, _props_styles_title, _props_styles;
    var isMobile = useMediaQuery(function(theme) {
        return theme.breakpoints.down('sm');
    });
    var hasContent = props.breadcrumb && !isMobile || props.children;
    return /*#__PURE__*/ _jsxs("header", {
        className: cn('Header', {
            'mb-4': isMobile && !((_props_className = props.className) === null || _props_className === void 0 ? void 0 : _props_className.includes('mb-')),
            'mb-8': !isMobile && !((_props_className1 = props.className) === null || _props_className1 === void 0 ? void 0 : _props_className1.includes('mb-'))
        }, props.className),
        "data-component": "Header",
        title: typeof props.title === 'string' ? props.title : undefined,
        children: [
            props.breadcrumb && /*#__PURE__*/ _jsx("span", {
                className: cn('truncate max-w-100 block', {
                    invisible: props.isLoading
                }),
                role: "presentation",
                children: props.breadcrumb
            }),
            props.isLoading ? /*#__PURE__*/ _jsx("span", {
                className: "flex",
                role: "presentation",
                children: /*#__PURE__*/ _jsx(Loading, {
                    className: "bg-grey600 mb-2",
                    height: 36,
                    width: 292
                })
            }) : /*#__PURE__*/ _jsxs("div", {
                className: cn('flex items-center', {
                    'mb-1': hasContent
                }),
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        className: cn((_props_styles = props.styles) === null || _props_styles === void 0 ? void 0 : (_props_styles_title = _props_styles.title) === null || _props_styles_title === void 0 ? void 0 : _props_styles_title.mobile, {
                            truncate: !isMobile
                        }),
                        color: "black",
                        component: "h1",
                        id: props.titleId,
                        mb: 0,
                        variant: isMobile ? 'd2' : 'c2',
                        children: props.title
                    }),
                    props.tooltip
                ]
            }),
            props.children && /*#__PURE__*/ _jsx(Content, {
                children: props.isLoading ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Loading, {
                            className: "bg-grey800 mr-8",
                            height: 36,
                            width: 95
                        }),
                        /*#__PURE__*/ _jsx(Loading, {
                            className: "bg-grey800 mr-8",
                            height: 36,
                            width: 95
                        }),
                        /*#__PURE__*/ _jsx(Loading, {
                            className: "bg-grey800",
                            height: 36,
                            width: 95
                        })
                    ]
                }) : props.children
            })
        ]
    });
};
Header.displayName = 'Header';

//# sourceMappingURL=Header.js.map